<template>
  <span>
    <a v-if="link" :href="link">{{ value }}</a>
    <template v-else>
      {{ value }}
    </template>
  </span>
</template>

<script>
export default {
  name: 'LinkValue',
  props: ['value'],
  computed: {
    link () {
      if (this.row.Link) {
        return this.row.Link
      } else {
        return false
      }
    }
  }
}
</script>
